import React from 'react';

const SvgTest = props => (
  <svg width={600.044} height={320.948} {...props} viewBox="0 0 346 146">
    <defs>
      <path id="test_svg__a" d="M-232.806-58.873h612v306h-612z" />
    </defs>
    <clipPath id="test_svg__b">
      <use xlinkHref="#test_svg__a" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#test_svg__b)"
      fill="none"
      stroke="#FFF"
      strokeWidth={1.25}
      strokeMiterlimit={10}
      d="M-238.806 247.127h-15m639 0h15m-639-306h-15m639 0h15m-633 312v15m0-333v-15m612 333v15m0-333v-15"
    />
    <path
      clipPath="url(#test_svg__b)"
      fill="none"
      stroke="#000"
      strokeWidth={0.25}
      strokeMiterlimit={10}
      d="M-238.806 247.127h-15m639 0h15m-639-306h-15m639 0h15m-633 312v15m0-333v-15m612 333v15m0-333v-15"
    />
    <defs>
      <path id="test_svg__c" d="M0-17.266h356.054v176.393H0z" />
    </defs>
    <clipPath id="test_svg__d">
      <use xlinkHref="#test_svg__c" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#test_svg__d)"
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M19.645 52.076L.368 46.769M19.645 94.603L.368 99.895"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M173.201.029v3.098"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      strokeDasharray="6.1 3.05"
      d="M173.201 6.177v135.73"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M173.201 143.432v3.098"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={2.065}
      strokeMiterlimit={10}
      d="M174.606.244v146.608"
    />
    <path fill="#808285" d="M171.668.245v146.607V.245z" />
    <path
      fill="none"
      stroke="red"
      strokeWidth={2.065}
      strokeMiterlimit={10}
      d="M171.667.244v146.608"
    />
    <path
      fill="#FFF"
      stroke="#00F"
      strokeWidth={4.13}
      strokeMiterlimit={10}
      d="M128.372.447v146.501M217.813.352v146.5"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M326.915 0v146.5"
    />
    <defs>
      <path id="test_svg__e" d="M0-17.266h356.054v176.393H0z" />
    </defs>
    <clipPath id="test_svg__f">
      <use xlinkHref="#test_svg__e" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#test_svg__f)"
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M164.21 146.756a8.75 8.75 0 0 1 17.5 0"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M326.769 52.054l19.275-5.308M326.769 94.58l19.275 5.292M19.508.267v146.501"
    />
    <g>
      <defs>
        <path id="test_svg__g" d="M0-17.266h356.054v176.393H0z" />
      </defs>
      <clipPath id="test_svg__h">
        <use xlinkHref="#test_svg__g" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#test_svg__h)"
        fill="none"
        stroke="#231F20"
        strokeWidth={1.549}
        strokeMiterlimit={10}
        d="M326.954 146.756c10.499 0 19.09-8.59 19.09-19.09V19.145c0-10.498-8.591-19.09-19.09-19.09H19.863C9.364.055.774 8.647.774 19.145v108.522c0 10.5 8.59 19.09 19.089 19.09h307.091z"
      />
    </g>
    <path fill="#231F20" d="M289.349 5.766v60.327V5.766z" />
    <path
      fill="none"
      stroke="red"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M289.347 5.766v60.328M283.828 5.849v60.243"
    />
    <g>
      <defs>
        <path id="test_svg__i" d="M0-17.266h356.054v176.393H0z" />
      </defs>
      <clipPath id="test_svg__j">
        <use xlinkHref="#test_svg__i" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        d="M286.549 62.264c-14.644 0-26.513-11.869-26.513-26.512s11.869-26.513 26.513-26.513c14.643 0 26.513 11.87 26.513 26.513s-11.871 26.512-26.513 26.512"
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={286.549}
        cy={35.751}
        r={26.512}
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M295.308 34.302h-5.398v-5.226M295.308 37.557h-5.398v5.537M277.554 34.302h5.539v-5.226M277.554 37.557h5.539v5.537"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#231F20"
        d="M289.347 81.573v60.328"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M289.347 81.573v60.328M283.828 81.656v60.245"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        d="M286.53 138.25c-14.643 0-26.513-11.871-26.513-26.514 0-14.642 11.87-26.512 26.513-26.512 14.644 0 26.514 11.87 26.514 26.512 0 14.643-11.87 26.514-26.514 26.514"
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={286.53}
        cy={111.738}
        r={26.513}
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M295.308 110.109h-5.398v-5.224M295.308 113.364h-5.398v5.537M277.554 110.109h5.539v-5.224M277.554 113.364h5.539v5.537"
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="#00F"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={173.201}
        cy={73.251}
        r={26.513}
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="#00F"
        stroke="#00F"
        strokeWidth={0.295}
        strokeMiterlimit={10}
        cx={173.237}
        cy={73.273}
        r={1.858}
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#231F20"
        d="M62.814 5.348v60.328"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M62.814 5.348v60.328M57.296 5.431v60.244"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        d="M59.998 62.023c-14.643 0-26.513-11.869-26.513-26.512S45.355 8.999 59.998 8.999c14.643 0 26.513 11.87 26.513 26.513s-11.87 26.511-26.513 26.511"
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={59.998}
        cy={35.511}
        r={26.512}
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M68.775 33.885h-5.397v-5.226M68.775 37.139h-5.397v5.537M51.021 33.885h5.539v-5.226M51.021 37.139h5.539v5.537"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#231F20"
        d="M62.814 81.155v60.328"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M62.814 81.155v60.328M57.296 81.239v60.244"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        stroke="red"
        strokeMiterlimit={10}
        d="M59.998 137.833c-14.643 0-26.513-11.871-26.513-26.513 0-14.643 11.87-26.512 26.513-26.512 14.643 0 26.513 11.87 26.513 26.512 0 14.641-11.87 26.513-26.513 26.513"
      />
      <circle
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={59.998}
        cy={111.32}
        r={26.513}
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M68.775 109.692h-5.397v-5.225M68.775 112.946h-5.397v5.537M51.021 109.692h5.539v-5.225M51.021 112.946h5.539v5.537"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        stroke="red"
        strokeMiterlimit={10}
        d="M331.536 81.619c1.977 0 3.58-1.589 3.58-3.549v-9.203c0-1.96-1.604-3.549-3.58-3.549h-4.57a.07.07 0 0 0-.07.07v16.181c0 .027.021.05.05.05h4.59z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M331.536 81.619c1.977 0 3.58-1.589 3.58-3.549v-9.203c0-1.96-1.604-3.549-3.58-3.549h-4.57a.07.07 0 0 0-.07.07v16.181c0 .027.021.05.05.05h4.59z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#ADD8E6"
        stroke="red"
        strokeMiterlimit={10}
        d="M316.856 83.913h9.994V62.958l-9.994.05c-2.924 2.635-4.827 6.215-4.827 10.441 0 4.259 1.865 7.826 4.827 10.464"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M316.856 83.913h9.994V62.958l-9.994.05c-2.924 2.635-4.827 6.215-4.827 10.441 0 4.259 1.865 7.826 4.827 10.464z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#FFF"
        d="M14.887 81.474c-1.978 0-3.58-1.589-3.58-3.549v-9.203c0-1.96 1.603-3.549 3.58-3.549h4.57c.038 0 .07.03.07.069v16.182a.05.05 0 0 1-.05.05h-4.59z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M14.887 81.474c-1.978 0-3.58-1.589-3.58-3.549v-9.203c0-1.96 1.603-3.549 3.58-3.549h4.57c.038 0 .07.03.07.069v16.182a.05.05 0 0 1-.05.05h-4.59z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="#ADD8E6"
        d="M29.566 83.768h-9.993V62.812l9.993.049c2.925 2.637 4.827 6.215 4.827 10.442.001 4.259-1.863 7.827-4.827 10.465"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="none"
        stroke="red"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M29.566 83.768h-9.993V62.812l9.993.049c2.925 2.637 4.827 6.215 4.827 10.442.001 4.259-1.863 7.827-4.827 10.465z"
      />
      <path
        clipPath="url(#test_svg__j)"
        fill="red"
        d="M207.508 37.354a1.858 1.858 0 1 1 0-3.716 1.858 1.858 0 0 1 0 3.716M207.508 113.335a1.858 1.858 0 1 1 0-3.717 1.858 1.858 0 0 1 0 3.717M138.594 37.354a1.858 1.858 0 1 1 0-3.716 1.858 1.858 0 0 1 0 3.716M138.594 113.335a1.858 1.858 0 1 1 0-3.717 1.858 1.858 0 0 1 0 3.717M59.914 112.806a1.487 1.487 0 1 1 0-2.974 1.487 1.487 0 0 1 0 2.974M59.914 36.998a1.487 1.487 0 1 1 0-2.974 1.487 1.487 0 0 1 0 2.974M286.53 37.416a1.487 1.487 0 1 1 .002-2.974 1.487 1.487 0 0 1-.002 2.974M286.53 113.224a1.487 1.487 0 1 1 .002-2.974 1.487 1.487 0 0 1-.002 2.974"
      />
    </g>
  </svg>
);

export default SvgTest;



// WEBPACK FOOTER //
// ./src/Components/SvgTest.js